import React from "react";
import PropTypes from "prop-types";

/* ============================
   Error Message & Retry Button
   ============================ */

const ErrorDisplay = ({ message, instructions, showRetry, onRetry }) => {
    if (!message) return null;

    return (
        <div className="scanner-error-box">
            <div className="scanner-error-message">{message}</div>

            {instructions && (
                <div className="scanner-error-instructions">
                    {instructions}
                </div>
            )}

            {showRetry && (
                <button
                    className="scanner-retry-button"
                    onClick={onRetry}
                >
                    Scan Again
                </button>
            )}
        </div>
    );
};

ErrorDisplay.propTypes = {
    message: PropTypes.string,
    instructions: PropTypes.string,
    showRetry: PropTypes.bool,
    onRetry: PropTypes.func,
};

export default ErrorDisplay;
